import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";

const PercentageLabel = ({
  applicable = true,
  percentage,
  tooltipTitle = "",
  negativePercentage = false,
  sx = {},
}) => {
  const colors = useColors();
  const calculatePercentage = !negativePercentage
    ? percentage
    : 100 - percentage;
  const getColors = (applicable, percentage, negativePercentage) => {
    let backgroundColor, textColor;

    if (!applicable) {
      backgroundColor = colors.common_white;
      textColor = colors.text_disabled;
    } else {
      if (
        (!negativePercentage && percentage >= 75) ||
        (negativePercentage && percentage <= 25)
      ) {
        backgroundColor = colors.mitre_green_label_fill;
        textColor = colors.mitre_green_label_text;
      } else if (percentage >= 50) {
        backgroundColor = colors.mitre_yellow_label_fill;
        textColor = colors.mitre_yellow_label_text;
      } else if (
        (!negativePercentage && percentage > 25) ||
        (negativePercentage && percentage <= 75)
      ) {
        backgroundColor = colors.mitre_orange_label_fill;
        textColor = colors.mitre_orange_label_text;
      }
      if (
        (!negativePercentage && percentage <= 25) ||
        (negativePercentage && percentage >= 75)
      ) {
        backgroundColor = colors.mitre_red_label_fill;
        textColor = colors.mitre_red_label_text;
      }
    }

    return { backgroundColor: backgroundColor, textColor: textColor };
  };

  const { backgroundColor, textColor } = getColors(
    applicable,
    calculatePercentage,
    negativePercentage
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: backgroundColor,
        border: `0.5px solid ${textColor}`,
        borderRadius: "10px",
        height: "20px",
        padding: "0px 8px",
        minWidth: "36px",
        justifyContent: "center",
        ...sx,
      }}
    >
      <CustomToolTip title={tooltipTitle} placement="top">
        <Typography
          variant="caption"
          sx={{
            textAlign: "center",
            color: textColor,
          }}
        >
          {applicable ? `${calculatePercentage}%` : "N/A"}
        </Typography>
      </CustomToolTip>
    </Box>
  );
};

export default PercentageLabel;
